<template>
<div class="container-fluid bg-white">
	<employees-toolbar></employees-toolbar>

	<addon-app-tab ui-location="Employees Module"></addon-app-tab>
</div>
</template>
<script type="text/javascript">
import EmployeesToolbar from "./EmployeesToolbar"
import AddonAppTab from "@/components/AddonAppTab"

export default {
	name: "EmployeesApps",
	components: {
		EmployeesToolbar,
		AddonAppTab
	}
}
</script>
